module.exports = __webpack_public_path__ + "static/jonghyeon.jeong-97f7a04d4cd63c164c8b1e72ae86ee67.png";